var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading && _vm.records
            ? [
                _c(
                  "table",
                  { staticClass: "table mt-1 table-sm table-hover" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.records, function (r, i) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(i + 1))]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [_c("DrugTitleView", { attrs: { drug: r.drug } })],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(r.qty))]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "form",
                              { staticClass: "flex align-items-center" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "mr-2" },
                                  [
                                    _vm.loadingRecord[r.drug_id]
                                      ? _c("clip-loader", {
                                          staticClass: "text-center",
                                          attrs: {
                                            loading: true,
                                            color: _vm.$constants.LOADING_COLOR,
                                            size: "20px",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: r.comments.text,
                                      expression: "r.comments.text",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.loadingRecord[r.drug_id],
                                    placeholder: "Комментарий",
                                  },
                                  domProps: { value: r.comments.text },
                                  on: {
                                    change: function ($event) {
                                      return _vm.updateStoreComment(r.drug_id)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        r.comments,
                                        "text",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Количество")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }